export const bookGtagEvent = ({ action, category, label, value }) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', 'reservar_ahora', {
      event_label: 'reservar_ahora',
      value: 1,
    })
  }
}